import ContentCopy from '@mui/icons-material/ContentCopy';
import Email from '@mui/icons-material/Email';
import Language from '@mui/icons-material/Language';
import WhatsApp from '@mui/icons-material/WhatsApp';
import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import LinkedIn from '@mui/icons-material/LinkedIn';
import Share from '@mui/icons-material/Share';
import X from '@mui/icons-material/X';
import YouTube from '@mui/icons-material/YouTube';

export const getMediaIconMui = (type: string) => {
  switch (type) {
    case 'youtube':
      return <YouTube />;
    case 'twitter':
      return <X />;
    case 'linkedin':
      return <LinkedIn />;
    case 'facebook':
      return <Facebook />;
    case 'instagram':
      return <Instagram />;
    case 'whatsapp':
      return <WhatsApp />;
    case 'website':
      return <Language />;
    case 'email':
      return <Email />;
    case 'link':
      return <ContentCopy />;
    case 'share':
      return <Share />;
    default:
      return <></>;
  }
};
